import Box from 'components/atoms/box'
import Button from 'components/atoms/button'
import Column from 'components/atoms/column'
import Modal from 'components/atoms/modal'
import Row from 'components/atoms/row'
import Text from 'components/atoms/text'
import CheckboxList from 'components/screens/courses/checkbox-list'
import React from 'react'
import { MarketProductCategoryType } from 'types/market-product-category-type'
import SelectSortOptionsFilter from './select-sort-option-filter'

export interface SearchFiltersModalProps {
  value?: MarketProductCategoryType[]
  options?: MarketProductCategoryType[]
  pending?: boolean
  onChange?: (options: MarketProductCategoryType[]) => void
  className?: string
  onClose?: () => void
  open?: boolean
}

const SearchFiltersModal: React.FC<SearchFiltersModalProps> = ({
  value,
  options,
  pending,
  onChange,
  onClose,
  open,
  className,
}) => {
  return (
    <Modal open={open} onClose={onClose} className={className}>
      <Box className="absolute inset-x-0 bottom-0 w-full bg-white py-lg px-md sm:px-lg md:px-xl  ">
        <Column className="pb-md">
          <Text className="pb-md text-base font-bold ">Ordenar por </Text>
          <SelectSortOptionsFilter className="max-w-[240px]" />
        </Column>
        <CheckboxList
          value={value}
          options={options}
          pending={pending}
          onChange={onChange}
        />
        <Row className="flex items-center justify-center pt-32  ">
          <Button
            className="w-[264px] rounded-[40px] text-sm"
            onClick={onClose}
          >
            Aplicar Filtro
          </Button>
        </Row>
      </Box>
    </Modal>
  )
}

export default SearchFiltersModal
